import _ from "underscore";
import $ from "jquery";

import React from 'react';
import PropTypes from 'prop-types';

import '../app';

import ExpressionCanvas from '../src/views/ExpressionCanvas';
import ToggleMode from '../src/views/ToggleMode';
import Sidebar from '../src/views/Sidebar';
import ExpressionAutoComplete from '../src/views/ExpressionAutoComplete';

var SYNC_DEBOUNCE_MS = 700;

class SignalBuilder extends React.Component {
  constructor(...args) {
    super(...args);

    this.state = {
      showText: false,
      validating: false
    };

    this._onInsertTerminal = this._onInsertTerminal.bind(this);
    this._onToggle = this._onToggle.bind(this);
    this._expressionTextChanged = this._expressionTextChanged.bind(this);
  }

  componentDidMount() {
    if (this.props.setup.editable) {
      this._validateExpressionTextWithDebounce = _.debounce(this._validateExpressionText, SYNC_DEBOUNCE_MS);
      this.props.model.on('change:expression', this.forceUpdate.bind(this, null), this);
      if (this.props.model.get('expression')) {
        this._validateExpressionText();
      }
      this._addValidationListeners();
    }
  }

  componentWillUnmount() {
    this.props.model.off(null, null, this);
  }

  _textInnerContent() {
    var innerContent;
    var expression = this.props.model.get('expression');
    if (this.props.setup.editable) {
      innerContent =
        <textarea
          className="form-control expression-canvas-edit"
          value={expression}
          onChange={this._expressionTextChanged}
          ref={
            function(input) {
              if (input) this.textarea = input;
            }.bind(this)
          }
        />;
    } else {
      innerContent = <span className="expression-text">{expression}</span>;
    }

    return innerContent;
  }

  _builderInnerContent() {
    return <ExpressionCanvas
      expressionText={this.props.model.get('expression')}
      expressionTerminals={this.props.model.expressionTerminals}
      selectUrls={this.props.selectUrls}
      selectValues={this.props.selectValues}
      editable={this.props.setup.editable}
      terminalMetaData={this.props.terminalMetaData}
    />;
  }

  render() {
    var innerContent;
    if (this.state.showText) {
      innerContent = this._textInnerContent();
    } else {
      innerContent = this._builderInnerContent();
    }

    var editable = this.props.setup.editable;
    if (editable) {
      return this._renderEditable(innerContent);
    } else {
      return this._renderReadOnly(innerContent);
    }
  }

  _renderReadOnly(innerContent) {
    return (
      <div className="container">
        {this._toggleModeElement()}
        {innerContent}
      </div>
    );
  }

  _renderEditable(innerContent) {
    return (
      <div className="row">
        <div className="col-md-4 col-lg-3 terminals">
          {this._sidebarElement()}
        </div>
        <div className="col-md-8 col-lg-9">
          {this._toggleModeElement()}
          {innerContent}
          <span className="sb-field-group">
            <span name="expression-errors" className="sb-field-invalid-feedback"></span>
            <span name="expression-warnings" className="sb-field-invalid-feedback color-warning"></span>
          </span>
        </div>
      </div>
    );
  }

  _sidebarElement() {
    return <Sidebar
      features={this.props.features}
      onInsertTerminal={this._onInsertTerminal}
      disabled={this.state.validating || this.state.showText}
      terminalMetaData={this.props.terminalMetaData}
    />;
  }

  _toggleModeElement() {
    var toggleEl = null;
    if (this.props.setup.showToggle) {
      toggleEl = <ToggleMode
        onToggle={this._onToggle}
        toggleOptions={["Builder", "Text"]}
        defaultSelected={this._toggleModeValue()}
        disabled={this._disableToggle()}
      />;
    }
    return toggleEl;
  }

  switchToTextMode() {
    this.setState({ showText: true });
  }

  expressionText() {
    var newText;

    if (this.state.showText) {
      newText = this.props.model.get('expression');
    } else {
      newText = this.props.model.expressionTerminals.expressionText();
    }

    var sanitizedExpression = newText.replace(/&nbsp;/, ' ').replace(/\s{2,}/, ' ');
    return sanitizedExpression;
  }

  _disableToggle() {
    return (
      this.state.validating || (
        this.state.showText && this.props.model.get('errors') &&
        !!Object.keys(this.props.model.get('errors')).length
      )
    );
  }

  _addValidationListeners() {
    this.props.model.on('validating:true', function() {
      this.setState({ validating: true });
    }.bind(this));
    this.props.model.on('validating:false', function() {
      this.setState({ validating: false });
    }.bind(this));
  }

  _expressionTextChanged(evt) {
    this.props.model.set('expression', evt.target.value);
    if (this.props.model.get('expression') === "") {
      this.props.model.expressionTerminals.reset();
    }
    this._validateExpressionTextWithDebounce();
  }

  _validateExpressionText() {
    this.props.model.validateExpression(function() {
      this.switchToTextMode();
    }.bind(this),
    this.state.showText);
  }

  _toggleModeValue() {
    if (this.state.showText) {
      return "Text";
    } else {
      return "Builder";
    }
  }

  _onToggle(view) {
    if (!this.state.showText) {
      var newText = this.expressionText();
      this.props.model.set('expression', newText);
      this.props.model.set('previouslyValidatedText', newText);
    }

    this.setState({ showText: view === "Text" });
    this._setTextareaFocusToEnd();

    if (this.props.toggleBuilderMode) {
      this.props.toggleBuilderMode(this._toggleModeValue());
    }
  }

  _onInsertTerminal(nodeName) {
    var nodeAttrs = { terminal: nodeName };
    var nodeConfig = this.props.terminalMetaData[nodeName] || {};

    if (nodeConfig.beforeInsert) {
      // to use beforeInsert, consumer is given the node attrs and a callback
      //  consumer must run its logic (or pop a dialog, etc) and when ready
      //  invoke the callback, passing the final version of the node attrs
      nodeConfig.beforeInsert.apply(this, [
        nodeAttrs,
        function(node) {
          this._insertNewTerminal(node);
        }.bind(this)
      ]);

      return;
    }

    this._insertNewTerminal(nodeAttrs);
  }

  _insertNewTerminal(node) {
    this.props.model.expressionTerminals.addTerminal(node);
  }

  _setTextareaFocusToEnd() {
    // the setTimeout is an ugly hack to wait for the DOM element to exist
    //  but we need to do this on the toggle callback [rather than in the component on render]
    //  because we only want to force focus on toggle, not if the user is typing
    //  or otherwise changing the textarea
    setTimeout(function() {
      if (this.state.showText && this.textarea) {
        this.textarea.focus();

        if (this.textarea.setSelectionRange) {
          this.textarea.setSelectionRange(this.textarea.value.length, this.textarea.value.length);
        }

        (new ExpressionAutoComplete(this.props.features)).init(this.textarea);

        $(this.textarea).on('change', function(evt) {
          this._expressionTextChanged(evt);
        }.bind(this));
      }
    }.bind(this), 10);
  }
}

SignalBuilder.propTypes = {
  features: PropTypes.object.isRequired,
  model: PropTypes.object.isRequired,
  terminalMetaData: PropTypes.object.isRequired,
  setup: PropTypes.object
};

SignalBuilder.defaultProps = {
  setup: {
    editable: true,
    showToggle: true
  }
};

export default SignalBuilder;
